// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__jO55g","list":"PatternAutocomplete_list__2V7Up"};